import { useQuery } from "@tanstack/react-query";
import { orgHierarchyService } from "@/services/orgHierarchyService";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Hook to determine if the current user is a leader (has direct reports)
 * @returns Object with isLeader boolean and loading state
 */
export function useIsLeader() {
  const { user } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ["direct-reports"],
    queryFn: () => orgHierarchyService.getDirectReports(),
    enabled: !!user?.pid,
  });

  const isLeader = data?.isLeader ?? false;

  return {
    user,
    isLeader,
    isLoading,
    directReports: data?.directReports ?? [],
  };
}
